import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import Select from '@ott/select';
import styles from './DropdownForCars.scss';
import { AGE_DEFAULT, AGE_OLD, AGE_YOUNGSTER } from '../../../consts';

const options = [
  { value: AGE_YOUNGSTER, label: 'Водителю 21–24 года' },
  { value: AGE_DEFAULT, label: 'Водителю 25–59 лет' },
  { value: AGE_OLD, label: 'Водителю больше 60 лет' },
];

const DropdownForCars = ({ input: { onChange, value } }) => {
  const handleOptionChange = useCallback(
    (optionValue) => {
      onChange(optionValue);
    },
    [onChange]
  );

  return (
    <Select
      onChange={handleOptionChange}
      childrenClassNames={{
        arrow: styles.arrow,
        trigger: styles.trigger,
        overlayContent: styles.options,
        triggerWrapper: styles.fitContent,
        inputContent: styles.inputContent,
      }}
      options={options}
      alignType="left"
      value={value}
      size="small"
    />
  );
};

DropdownForCars.displayName = 'DropdownForCars';

DropdownForCars.propTypes = {
  input: PropTypes.shape({
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
  }),
};

export default DropdownForCars;
